import * as React from 'react';

import { cn } from '@/lib/utils';
import { focusRingClassNames } from './utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
    return (
        <textarea
            data-slot="textarea"
            data-private
            className={cn(
                'border-input light:placeholder:text-gz-neutral-800 dark:placeholder:text-gz-neutral-100 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                focusRingClassNames,
                // Session replay records the field as a blank box, so typed values never reach it.
                'rr-block',
                className,
            )}
            {...props}
        />
    );
}

export { Textarea };
